import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { observer } from 'mobx-react';
import { AgenturErrungenschaften } from 'app/components/errungenschaften/AgenturErrungenschaften';
import { useStore } from 'app/context';
import Config from 'Config';

export const AgenturErrungenschaftenWidget = observer((props: IWidgetConsumer) => {
	const { agenturUiStore } = useStore();
	if (Config.disableErrungenschaften) {
		return <></>
	}
	return (
		<>
			{agenturUiStore.current && agenturUiStore.current.supportsErrungenschaften && (
				<Widget title={'Errungenschaften'} widgetId={props.widgetKey}>
					<AgenturErrungenschaften />
				</Widget>
			)}
		</>
	);
});
